export default __webpack_public_path__ + "static/my_image-a1e12cfb1409f0d5004c162b24062e02.jpg";